import axios, { AxiosRequestConfig, Method, AxiosResponse, ResponseType, AxiosRequestHeaders } from 'axios'
import qs from 'qs'
import { loggerService } from './logger.service'
import storageService from './storage.service'

const getBaseApiUrl = () => {
  return process.env.REACT_APP_BASE_API_URL
}

const baseRequest = (
  cancelSignal: AbortController,
  uri: string,
  method_: Method,
  queryStringParams?: any,
  payload?: any,
  headers?: AxiosRequestHeaders,
  response_type?: ResponseType,
): Promise<AxiosResponse<any>> => {
  let config: AxiosRequestConfig = {
    method: method_,
    url: getBaseApiUrl() + '/' + uri,
    signal: cancelSignal.signal,
  }

  if (!!queryStringParams) {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
    config.params = { ...queryStringParams }
  }

  if (response_type !== undefined) config.responseType = response_type
  if (payload) config.data = payload
  const language = storageService.getLanguage()
  if (language) {
    headers = { ...headers, 'Accept-Language': language }
  }
  if (headers) config.headers = headers
  else config.headers = {}

  return axios.request(config)
}

const baseApiCall = (
  uri: string,
  method_: Method,
  queryStringParams?: any,
  payload?: any,
  setSuccess?: (data: any) => void,
  setError?: (error: any) => void,
  headers?: AxiosRequestHeaders,
  response_type?: ResponseType,
): AbortController => {
  const controller = new AbortController()

  baseRequest(controller, uri, method_, queryStringParams, payload, headers, response_type)
    .then((res) => {
      if (setSuccess) setSuccess(res.data)
    })
    .catch((e) => {
      if (e.name !== 'CanceledError') {
        loggerService.error(e)
        if (setError) setError(e)
        else Promise.reject(e)
      }
    })

  return controller
}

export const apiClientService = {
  getBaseApiUrl,
  baseRequest,
  baseApiCall,
}
